import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import '@mdi/font/css/materialdesignicons.css'

Vue.use(Vuetify);

export default new Vuetify({
   icons: {
      iconfont: 'mdi', // default - only for display purposes
   },
   theme: {
      options: {
         customProperties: true,
       },
      themes: {
         light: {
            primary: '#d90458',
            secondary: '#a6003e',
            tertiary: '#016bbf',
            accent: '#8c9eff',
            error: '#b71c1c',
            gris: '#edf1f5',
            violet: '#871d81',
            rubine: '#e2001a',
            brown:'#ba0041'
         }
      }
   }, 
});
